 //const devBaseURL = "https://dev.kustomtickets.com:5443";
 const devBaseURL = "https://www.kustomtickets.com:3443";
const proBaseURL = "https://www.kustomtickets.com:3443";
export const BASE_URL =
  process.env.NODE_ENV === "development" ? devBaseURL : proBaseURL;

export const TIMEOUT = 10000;
